// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const balloon = "Balloon__balloon__wW0hk";
export const balloonInner = "Balloon__balloonInner__Azr9F";
export const bold = "700";
export const centered = "Balloon__centered__+GYUx";
export const downArrow = "Balloon__downArrow__i1EqI";
export const edmundsLogo = "Balloon__edmundsLogo__pWwk3";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const leftArrow = "Balloon__leftArrow__hkM8y";
export const link = "Balloon__link__dOCtE";
export const medium = "500";
export const regular = "400";
export const rightArrow = "Balloon__rightArrow__6D9w8";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const upArrow = "Balloon__upArrow__jrrJF";
export const value = "Balloon__value__JGtGZ";
export const valueExplanation = "Balloon__valueExplanation__q1TqP";
export const zillowLogo = "Balloon__zillowLogo__N7tK4";